import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, PassengerResponseDTO } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetClientsUsersCommand extends IRequestCommand<
  Array<IGetClientsUsersResponse>,
  ErrorDetails,
  IGetClientsUsersCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _needAuthenticate = true;
  public override setParameters(parameters: IGetClientsUsersCommandParameters) {
    this.urlSections.push('passengers');
    this.urlSections.push(`carrier/${parameters.carrierId}`);
    if(parameters.terms){
      this.paramsSections.push(`lastName=${parameters.terms}`);
    }
    if(parameters.paxId){
      this.paramsSections.push(`paxId=${parameters.paxId}`);
    }
    if (!!parameters.contractorId) {
      this.paramsSections.push(`contractor=${parameters.contractorId}`);
    }
    this.composeUrl();
  }
}

export interface IGetClientsUsersCommandParameters extends ICommandParameters {
  terms?: string;
  paxId?: string;
  carrierId?: string;
  contractorId?: string
}

export interface IGetClientsUsersResponse
  extends ICommandResponse,
    PassengerResponseDTO {}
